<template>
  <div>
    <div class="container_room">
      <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
        <v-progress-circular
          indeterminate
          class="mr-2"
          color="#006341"
        ></v-progress-circular>
        <b class="color_default">Loading</b>
      </v-overlay>
      <div class="list_person">
        <div class="head_chat_2 px-2 d-flex align-center justify-space-between">
          <v-icon color="var(--g)" @click="getBack">mdi-arrow-left</v-icon>
          <b class="color_default">Recent Chat</b>
        </div>
        <div class="pa-2 contacted_list" v-if="contacted || pinned">
          <!-- ========================================================= PINNED CHAT -->
          <div
            v-if="pinned"
            :class="
              pinned.recent_recipient.id == receiver.id
                ? 'active_recent'
                : 'unactive_recent'
            "
            @click="switchReceiver(pinned.recent_recipient)"
          >
            <v-avatar dark class="mr-2" size="35">
              <img
                :src="
                  pinned.recent_recipient.profile_picture
                    ? pinned.recent_recipient.profile_picture
                    : ava
                "
                alt=""
                class="obj_fit"
              />
            </v-avatar>
            <div style="flex-grow: 1">
              <div class="d-flex justify-space-between align-end">
                <b
                  class="color_default"
                  v-snip="1"
                  v-html="pinned.recent_recipient.name"
                >
                </b>
                <div class="d-flex">
                  <v-icon small style="transform: rotate(30deg)"
                    >mdi-pin</v-icon
                  >
                  <v-menu offset-y nudge-bottom="5px" nudge-left="80px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on">
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0" color="#EDF1F0" dense>
                      <v-list-item link @click="pinChat(pinned)">
                        <v-list-item-title>
                          <div class="d-flex align-center">
                            <v-icon
                              class="mr-1"
                              small
                              style="transform: rotate(30deg)"
                              >mdi-pin-off</v-icon
                            >
                            <p class="ma-0">Unpin Chat</p>
                          </div>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item link>
                        <v-list-item-title @click="archiveChat(pinned)">
                          <v-icon class="mr-1" small
                            >mdi-archive-arrow-down-outline</v-icon
                          >
                          Archive chat
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
              <div class="d-flex justify-space-between align-end">
                <p
                  class="default_txt"
                  v-snip="1"
                  v-html="pinned.recent_message"
                ></p>
                <p class="default_txt">
                  {{ $date(pinned.recent_message_updated_at).format("HH:mm") }}
                </p>
              </div>
            </div>
          </div>
          <!-- ========================================================= GENERAL CHAT -->

          <div
            v-for="(person, i) in contacted"
            :key="`contacted-${i}`"
            :class="
              person.recent_recipient.id == receiver.id
                ? 'active_recent'
                : 'unactive_recent'
            "
            @click="switchReceiver(person.recent_recipient)"
          >
            <v-avatar dark class="mr-2" size="35">
              <img
                :src="
                  person.recent_recipient.profile_picture
                    ? person.recent_recipient.profile_picture
                    : ava
                "
                alt=""
                class="obj_fit"
              />
            </v-avatar>
            <div style="flex-grow: 1">
              <div class="d-flex justify-space-between align-end">
                <b
                  class="color_default"
                  v-snip="1"
                  v-html="person.recent_recipient.name"
                >
                </b>
                <v-menu offset-y nudge-bottom="5px" nudge-left="80px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on">
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="pa-0" color="#EDF1F0" dense>
                    <v-list-item link @click="pinChat(person)">
                      <v-list-item-title>
                        <div class="d-flex align-center">
                          <v-icon
                            small
                            class="mr-1"
                            style="transform: rotate(30deg)"
                            >mdi-pin</v-icon
                          >
                          <p class="ma-0">Pin Chat</p>
                        </div>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item link>
                      <v-list-item-title @click="archiveChat(person)">
                        <v-icon class="mr-1" small
                          >mdi-archive-arrow-down-outline</v-icon
                        >
                        Archive chat
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div class="d-flex justify-space-between align-end">
                <div
                  class="d-flex align-center"
                  v-if="person.recent_message_sender_id == id"
                >
                  <v-icon
                    class="mr-1"
                    :color="person.read_at ? 'blue' : ''"
                    small
                    >mdi-check-all</v-icon
                  >
                  <p
                    class="default_txt"
                    v-snip="1"
                    v-html="person.recent_message"
                  ></p>
                </div>
                <div v-else>
                  <b
                    v-if="!person.read_at || person.user_id == interlocutors"
                    class="default_txt"
                    v-snip="1"
                    v-html="person.recent_message"
                  ></b>
                  <p
                    v-else
                    class="default_txt"
                    v-snip="1"
                    v-html="person.recent_message"
                  ></p>
                </div>
                <p class="default_txt">
                  {{ $date(person.recent_message_updated_at).format("HH:mm") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chat_room" v-if="interlocutors">
        <div class="head_chat px-2 d-flex align-center">
          <div v-if="receiver" class="d-flex align-center">
            <v-icon color="var(--g)" class="mr-2 hidden_arrow" @click="toRecent"
              >mdi-arrow-left</v-icon
            >

            <v-avatar dark class="mr-2" size="35">
              <img
                :src="receiver.profile_picture ? receiver.profile_picture : ava"
                alt=""
                class="obj_fit"
              />
            </v-avatar>
            <div>
              <b class="color_default"> {{ receiver.name }} </b>
              <p class="default_txt">
                {{ receiver.role ? receiver.role.toLowerCase() : "" }}
              </p>
            </div>
          </div>
        </div>
        <div class="temp_chat" v-if="allMsg">
          <v-overlay
            :absolute="true"
            color="white"
            opacity="1"
            :value="loadMsg"
          >
            <v-progress-circular
              indeterminate
              class="mr-2"
              color="#006341"
            ></v-progress-circular>
            <b class="color_default">Loading</b>
          </v-overlay>
          <div class="pa-2" v-if="allMsg.length">
            <div v-for="(chat, n) in allMsg" :key="`chatke-${n}`">
              <div class="d-flex justify-center">
                <div
                  class="date_sparator my-2"
                  v-if="
                    n != 0 &&
                    $date(allMsg[n].created_at).format('YYYY MM DD') !==
                      $date(allMsg[n - 1].created_at).format('YYYY MM DD')
                  "
                >
                  <small>{{
                    $date(chat.created_at).format("YYYY-MM-DD") == today
                      ? "Today"
                      : $date(chat.created_at).format("YYYY-MM-DD") == yesterday
                      ? "yesterday"
                      : $date(chat.created_at).format("DD,MM,YYYY")
                  }}</small>
                </div>
                <div class="date_sparator my-2" v-else-if="n == 0">
                  <small>{{
                    $date(chat.created_at).format("YYYY-MM-DD") == today
                      ? "Today"
                      : $date(chat.created_at).format("YYYY-MM-DD") == yesterday
                      ? "Yesterday"
                      : $date(chat.created_at).format("DD,MM,YYYY")
                  }}</small>
                </div>
              </div>
              <div
                :id="chat.id"
                :class="chat.user_id == id ? 'my_temp' : 'your_temp'"
              >
                <div v-if="chat.user_id != id" class="temp_ava">
                  <v-avatar dark class="mr-2" size="35" v-if="n == 0">
                    <img
                      :src="
                        chat.data_user.profile_picture
                          ? chat.data_user.profile_picture
                          : ava
                      "
                      class="obj_fit"
                      alt=""
                    />
                  </v-avatar>
                  <v-avatar
                    dark
                    class="mr-2"
                    size="35"
                    v-else-if="
                      n !== 0 && allMsg[n].user_id != allMsg[n - 1].user_id
                    "
                  >
                    <img
                      :src="
                        chat.data_user.profile_picture
                          ? chat.data_user.profile_picture
                          : ava
                      "
                      alt=""
                      class="obj_fit"
                    />
                  </v-avatar>
                </div>
                <div :class="chat.user_id == id ? 'my_half' : 'your_half'">
                  <div style="color: #006341" v-if="chat.user_id != id">
                    <b class="name_sender" v-if="n == 0"> {{ chat.name }} </b>
                    <b
                      class="name_sender"
                      v-else-if="
                        n !== 0 && allMsg[n].user_id != allMsg[n - 1].user_id
                      "
                    >
                      {{ chat.name }}
                    </b>
                  </div>
                  <v-hover v-slot="{ hover }">
                    <div
                      :class="chat.user_id == id ? 'my_ballon' : 'your_ballon'"
                    >
                      <div>
                        <div
                          :class="chat.user_id == id ? 'my_reply' : 'ur_reply'"
                          v-if="chat.reply_id"
                        >
                          <p class="ma-0 mr-2" v-snip="3">
                            {{ chat.reply_message }}
                          </p>
                        </div>
                        <!-- <div v-if="chat.image">
                          <img
                            :src="chat.image"
                            @click="viewImage(chat)"
                            class="image_in_msj"
                            alt=""
                          />
                        </div> -->
                        <p class="ma-0 pre_format" v-html="chat.message"></p>
                      </div>
                      <div
                        class="d-flex justify-space-between align-end"
                        style="height: 28px"
                      >
                        <p class="default_txt">
                          {{ $date(chat.created_at).format("HH:mm") }}
                        </p>
                        <v-expand-x-transition>
                          <div class="d-flex justify-end" v-if="hover">
                            <v-card
                              class="temp_rpl d-flex align-center"
                              color="#f6f6f6"
                              flat
                            >
                              <v-btn icon small @click="replyChat(chat)">
                                <v-icon class="mr-1" small>mdi-reply</v-icon>
                              </v-btn>
                              <v-btn
                                icon
                                small
                                v-if="chat.user_id == id"
                                @click="deleteData(chat)"
                              >
                                <v-icon class="mr-1" small>mdi-delete</v-icon>
                              </v-btn>
                            </v-card>
                          </div>
                        </v-expand-x-transition>
                      </div>
                    </div>
                  </v-hover>
                </div>
                <div v-if="chat.user_id == id" class="temp_ava">
                  <v-avatar dark class="ml-2" size="35" v-if="n == 0">
                    <img
                      :src="
                        chat.data_user.profile_picture
                          ? chat.data_user.profile_picture
                          : ava
                      "
                      class="obj_fit"
                      alt=""
                    />
                  </v-avatar>
                  <v-avatar
                    dark
                    class="ml-2"
                    size="35"
                    v-else-if="
                      n !== 0 && allMsg[n].user_id != allMsg[n - 1].user_id
                    "
                  >
                    <img
                      :src="
                        chat.data_user.profile_picture
                          ? chat.data_user.profile_picture
                          : ava
                      "
                      alt=""
                      class="obj_fit"
                    />
                  </v-avatar>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="typing_pace">
          <div class="temp_reply pa-2" v-if="dataReply">
            <v-btn
              icon
              color="#6FA287"
              class="mt-1 mr-2"
              @click="dataReply = null"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <div class="strip_rep">
              <b class="name_sender"> {{ dataReply.name }} </b>
              <p class="default_txt" v-snip="1">{{ dataReply.message }}</p>
            </div>
          </div>
          <div class="d-flex pa-2">
            <!-- <v-btn icon color="#6FA287" class="mt-1 mr-2">
              <v-icon>mdi-paperclip</v-icon>
            </v-btn> -->
            <v-card flat outlined class="d-flex" style="width: 100%">
              <v-textarea
                class="typing rounded-lg pa-0"
                v-model="msg"
                rows="1"
                id="chat-message-typer-textarea"
                auto-grow
                row-height="10"
                :disabled="sending"
                placeholder="type message"
                solo
                @keydown.enter.exact.prevent="checkType('text')"
                @keydown.enter.shift.exact.prevent="msg += '\n'"
                flat
                ref="typist"
                hide-details
              ></v-textarea>
              <v-btn
                icon
                color="#6FA287"
                class="mt-1 mr-2"
                @click="checkType('text')"
                v-if="!sending"
              >
                <v-icon style="transform: rotate(-40deg)"
                  >mdi-send-outline</v-icon
                >
              </v-btn>
              <v-progress-circular
                v-if="sending"
                indeterminate
                size="25"
                class="mt-2 mr-2"
                color="#006341"
              ></v-progress-circular>
            </v-card>
          </div>
        </div>
      </div>
      <div
        class="chat_room d-flex flex-column justify-center align-center"
        v-else
      >
        <v-icon size="100" color="var(--g)">mdi-forum</v-icon>
        <h3>Pick people from Networking to start the conversation!</h3>
        <v-btn
          class="text-capitalize mt-3"
          depressed
          color="var(--g)"
          dark
          to="/networking/net/management-networking"
          ><v-icon class="mr-2">mdi-web</v-icon>Networking</v-btn
        >
        <!-- <div class="temp_chat"></div> -->
      </div>
    </div>
    <div class="pa-1">
      <v-snackbar v-model="pinning" left :timeout="-1">
        {{ txt }}
      </v-snackbar>
      <dialog-pm
        :d_pm="d_pm"
        @refetch="fetchData"
        @close="d_pm = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
        :width="d_width"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DialogPm from "./dialogPm.vue";
export default {
  components: { DialogPm },
  name: "privateChat",
  computed: {
    ...mapState({
      id: (state) => state.id,
      ava: (state) => state.ava,
      profile: (state) => state.profile,
    }),
  },
  data() {
    return {
      receiver: {
        id: null,
      },
      contacted: null,
      allMsg: null,
      loading: false,
      loadMsg: false,
      sending: false,
      typeMsg: "",
      msg: "",
      txt: "",
      today: this.$date().format("YYYY-MM-DD"),
      yesterday: this.$date().subtract(1, "day").format("YYYY-MM-DD"),
      timestamp: this.$date(),
      session: null,

      d_pm: false,
      d_type: "",
      d_title: "",
      d_width: "450px",
      inventory: null,
      dataReply: null,
      isMemberShow: false,
      interlocutors: null,
      pinned: null,
      pinning: false,
    };
  },
  mounted() {
    let vm = this;
    window.Echo.channel(`personal-chat-recent-${vm.id}`).listen(
      "PersonalChatRecentEvent",
      (e) => {
        console.log("recent", e);
        vm.mutateRecentList(e);
      }
    );

    this.interlocutors = localStorage.getItem("with");
    if (this.interlocutors) {
      this.fetchData(true);
    }

    this.fetchRecent(true);
    this.onFocused();
  },
  methods: {
    mutateRecentList(item) {
      let vm = this;
      let idx = vm.contacted.findIndex((i) => {
        return i.id === item.data.id;
      });
      if (idx >= 0) {
        // this.contacted[idx] = item;
        vm.$set(vm.contacted, idx, item.data);
        setTimeout(() => {
          vm.contacted.sort((a, b) => {
            return (
              new Date(b.recent_message_updated_at) -
              new Date(a.recent_message_updated_at)
            );
          });
        }, 100);
      } else {
        vm.contacted.unshift(item.data);
      }
    },
    switchReceiver(item) {
      this.interlocutors = item.id;
      localStorage.setItem("with", this.interlocutors);
      this.loadMsg = true;
      let obj = {
        id: item.id,
        username: item.username,
        name: item.name,
        profile_picture: item.profile_picture,
        email: item.email,
        role: item.role,
        recent_id: item.id,
      };
      this.receiver = obj;
      let mq = window.matchMedia("(max-width: 768px)");
      if (mq.matches) {
        let chat = document.querySelector(".chat_room");
        let person = document.querySelector(".list_person");
        chat.style.width = "100%";
        person.style.width = "0";
      }
      let vm = this;
      window.Echo.leave(`personal-chat-${vm.session}`);
      this.fetchData();
    },
    toRecent() {
      let chat = document.querySelector(".chat_room");
      let person = document.querySelector(".list_person");
      let mq = window.matchMedia("(max-width: 768px)");
      if (mq.matches) {
        chat.style.width = "0";
        person.style.width = "100%";
      }
      this.receiver["id"] = null;
    },
    listener() {
      let vm = this;
      window.Echo.channel(`personal-chat-${vm.session}`).listen(
        "PersonalChatEvent",
        (e) => {
          console.log(e);
          if (e.chat_type == "send") {
            e.chat_data["name"] = e.data_user.name;
            e.chat_data["user_id"] = e.data_user.id;
            e.chat_data["data_user"] = e.data_user;
            vm.allMsg.push(e.chat_data);
            vm.sending = false;
            vm.scrollDown();
          } else if (e.chat_type == "delete") {
            vm.fetchData();
          }
          vm.onFocused();
        }
      );
    },
    // focus ke text area
    onFocused() {
      setTimeout(() => {
        this.$refs["typist"].$refs.input.focus();
      }, 100);
    },
    fetchData(first) {
      if (first) {
        this.loading = true;
      }
      let recipient = localStorage.getItem("with");
      let data = {
        path: `sn/chat/with?with=${recipient}`,
      };
      this.$store.dispatch("chat/getData", data).then((data) => {
        this.allMsg = data.data.chat;
        this.receiver = data.data.recipient;
        this.session = data.data.session;
        if (this.session) {
          this.listener();
        }
        this.loadMsg = false;
        this.loading = false;
        this.scrollDown();
      });
    },
    fetchRecent(first) {
      if (first) {
        this.loading = true;
      }
      let data = {
        path: `sn/chat/recent`,
      };
      this.$store.dispatch("chat/getData", data).then((data) => {
        let unpin = [];
        let pin = null;
        data.data.forEach((el) => {
          if (el.pinned == 1) {
            pin = el;
          } else {
            unpin.push(el);
          }
        });
        this.contacted = unpin;
        this.pinned = pin;
        this.loading = false;
        this.txt = pin ? "Chat pinned" : "Chat unpinned";

        setTimeout(() => {
          this.pinning = false;
        }, 800);
      });
    },
    checkType(type) {
      this.typeMsg = type;
      if (type == "text") {
        if (this.msg !== "") {
          this.sendMsg();
        }
      } else {
        this.sendMsg();
      }
    },
    replyChat(chat) {
      this.dataReply = chat;
      this.onFocused();
    },
    sendMsg() {
      this.sending = true;
      let body = {
        session_id: this.session,
        recipient_id: this.receiver.id,
        type: this.typeMsg,
        message: this.msg,
        reply_id: this.dataReply ? this.dataReply.id : null,
      };
      let data = {
        path: `sn/chat/send`,
        body: body,
      };
      this.$store
        .dispatch("chat/postApi", data)
        .then((data) => {
          this.msg = "";
          this.dataReply = null;
          if (!this.session) {
            this.session = data.data.session.id;
            this.listener();
          }
          this.sending = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.sending = false;
        });
    },
    scrollDown() {
      setTimeout(function () {
        let down = document.querySelector(".temp_chat");
        down.scrollTop = down.scrollHeight; //auto scroll bottom of page
      }, 100);
    },
    deleteData(item) {
      this.d_type = "d_msg";
      this.inventory = item;
      this.d_width = "max-content";
      this.d_title = "Delete Message";
      this.d_pm = true;
    },
    showMember() {
      this.isMemberShow = !this.isMemberShow;
      let chat = document.querySelector(".chat_room");
      let person = document.querySelector(".list_person");
      if (this.$vuetify.breakpoint.smAndDown) {
        if (this.isMemberShow) {
          person.style.width = "100%";
          chat.style.width = "0";
        } else {
          chat.style.width = "100%";
          person.style.width = "0";
        }
      } else {
        if (this.isMemberShow) {
          chat.style.width = "65%";
          person.style.width = "35%";
        } else {
          chat.style.width = "100%";
          person.style.width = "0";
        }
      }
    },
    archiveChat(item) {
      this.loading = true;
      let body = {
        recent_id: item.id,
      };
      let data = {
        path: `sn/chat/recent/delete`,
        body: body,
      };
      this.$store
        .dispatch("chat/postApi", data)
        .then((data) => {
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          localStorage.removeItem("with");
          this.interlocutors = null;
          this.fetchRecent(false);
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    pinChat(item) {
      this.pinning = true;
      let body = {
        recent_id: item.id,
        pinned: item.pinned == 0 ? 1 : 0,
      };
      this.txt = item.pinned == 0 ? "Pinning" : "Unpinning";
      let data = {
        path: `sn/chat/recent/pin`,
        body: body,
      };
      this.$store
        .dispatch("chat/postApi", data)
        .then(() => {
          this.fetchRecent(false);
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    getBack() {
      this.$router.push("/networking/net/management-networking");
    },
  },
};
</script>

<style scoped>
.delivery {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background: blue;
  margin-right: 2px;
}
.hidden_arrow {
  display: none;
}
.active_recent {
  display: flex;
  align-items: center;
  padding: 10px 5px;
  margin-bottom: 5px;
  border-radius: 8px;
  background: #c2dad2;
  cursor: pointer;
  transition: 1s all;
}
.unactive_recent {
  display: flex;
  align-items: center;
  padding: 10px 5px;
  margin-bottom: 5px;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: 1s all;
}
.date_sparator {
  background: rgb(35, 150, 35);
  border-radius: 5px;
  padding: 5px 10px;
  color: #fff;
}
.name_sender {
  font-size: 13px;
}
.container_room {
  display: flex;
  width: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 10px;
}
.chat_room {
  position: relative;
  width: 65%;
  height: 90vh;
  background: #fff;
  transition: all 0.3s;
}
.list_person {
  overflow: hidden;
  width: 35%;
  height: 90vh;
  z-index: 3;
  background: #fff;
  transition: all 0.3s;
  border-right: 1px solid #e3e1e1;
}
.temp_ava {
  width: 43px;
}
.head_chat {
  height: 8vh;
  border-bottom: 1px solid #e3e1e1;
}
.head_chat_2 {
  height: 8vh;
  width: 100%;
  border-bottom: 1px solid #e3e1e1;
}
.temp_chat {
  height: 72vh;
  overflow-y: scroll;
  scroll-behavior: smooth !important;
  scrollbar-width: thin;
}
.contacted_list {
  height: 80vh;
  overflow-y: auto;
  scroll-behavior: smooth !important;
  scrollbar-width: thin;
  transition: 1s all;
}
.typing_pace {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.typing {
  font-size: small;
  line-height: 1.6 !important;
}
.v-textarea textarea {
  line-height: 1.5 !important;
  margin-top: 15px !important;
}
/* width */
::-webkit-scrollbar {
  width: 5px;
  background: #fff;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.temp_reply {
  display: flex;
  width: 100%;
  background: #f6f6f6;
}
.strip_rep {
  border-left: solid 3px #006341;
  padding: 2px 10px;
}
.pre_format {
  word-break: break-all;
  white-space: pre-wrap;
}

/* chatt */
.my_temp {
  padding: 5px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  transition: 0.5s;
  /* margin-bottom: 10px; */
  border-radius: 5px;
}
.my_half {
  display: flex;
  justify-content: flex-end;
  width: 70%;
}
.my_ballon {
  position: relative;
  background: #006341;
  padding: 5px;
  border-radius: 10px 0 10px 10px;
  color: #fff;
  transition: 2s all !important;
  min-width: 200px;
  /* width: max-content; */
}
.ur_reply {
  word-break: break-all;
  white-space: pre-wrap;
  padding: 5px;
  cursor: pointer;
  background: #e4e3e3;
  border-left: solid 3px #006341;
  border-radius: 0 10px 0 0;
}
.my_reply {
  word-break: break-all;
  white-space: pre-wrap;
  padding: 5px;
  cursor: pointer;
  background: #078257;
  border-left: solid 3px #fff;
}
.your_temp {
  padding: 5px;
  display: flex;
  justify-content: flex-start;
  width: 100%;
  transition: 0.5s;
  border-radius: 5px;
}
.your_half {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 70%;
}
.your_ballon {
  position: relative;
  background: #f1f1f1;
  padding: 5px;
  border-radius: 0 10px 10px 10px;
  transition: 2s all !important;
  min-width: 200px;
}

@media (max-width: 1200px) {
}
@media (max-width: 925px) {
}
@media (max-width: 825px) {
}
@media (max-width: 768px) {
  .list_person {
    position: absolute;
    width: 100%;
  }

  .head_chat_2 {
    border-left: 1px #fff;
  }
  .hidden_arrow {
    display: block;
  }
}
@media (max-width: 576px) {
}
@media (max-width: 396px) {
  .temp_ava {
    display: none;
  }
}
</style>
